import { useAppSelector } from 'hooks';
import Steps from 'components/Steps';

import { getBankAccountStep, getIsConfigurationTab } from '../selectors';

const BankingModalStepper = () => {
  const step = useAppSelector(getBankAccountStep);
  const isConfigurationTab = useAppSelector(getIsConfigurationTab);

  if (isConfigurationTab) {
    return null;
  }

  return (
    <div className="pr-6">
      <Steps step={step - 1} stepsLength={2} />
    </div>
  );
};

export default BankingModalStepper;
